<template>
    <div class="bg-white shadow px-6 py-4 relative flex flex-col desktop:flex-row desktop:justify-center items-center print:flex-row print:shadow-none">
        <div class="w-full flex flex-row justify-between print:w-1/2">
            <a href="/">                 
                 <img class="w-48 max-h-10" fetchpriority="high" src="/images/breezeline2.webp" alt="Breezeline Logo" />
            </a>

            <div class="flex justify-end items-start desktop:hidden">
                <button class="buyflow-chat-header ccai-mobile-launcher" id="buyflow-chat-header" aria-label="Chat">
                    <div class="buyflow-button-alt buyflow-custom-chat-button p-0 flex items-center justify-center">
                        <svg class="buyflow-chat-header-icon" viewBox="0 0 100 100" focusable="false" role="image" aria-hidden="true">
                            <path d="M25,54.1677083 L75,54.1677083 L75,50.0005208 L25,50.0005208 L25,54.1677083 Z M25,37.5005208 L75,37.5005208 L75,33.3333333 L25,33.3333333 L25,37.5005208 Z M42.03125,95.8333333 L37.5,95.8333333 L37.5,91.6661458 L42.03125,91.6661458 C48.721875,91.6661458 54.7375,87.9489583 57.7296875,81.9645833 L60.6359375,76.1520833 C60.9890625,75.4458333 61.7109375,75.0005208 62.5,75.0005208 L64.5828125,75.0005208 C81.8140625,75.0005208 95.8328125,60.9817708 95.8328125,43.7505208 C95.8328125,26.5192708 81.8140625,12.5005208 64.5828125,12.5005208 L35.415625,12.5005208 C18.184375,12.5005208 4.165625,26.5192708 4.165625,43.7505208 C4.165625,60.9817708 18.184375,75.0005208 35.415625,75.0005208 L37.5,75.0005208 L37.5,79.1661458 L35.415625,79.1661458 C15.8875,79.1661458 0,63.2786458 0,43.7505208 C0,24.2208333 15.8875,8.33333333 35.415625,8.33333333 L64.5828125,8.33333333 C84.1109375,8.33333333 100,24.2208333 100,43.7505208 C100,63.2786458 84.1109375,79.1661458 64.5828125,79.1661458 L63.7875,79.1661458 L61.45625,83.8286458 C57.753125,91.2333333 50.3109375,95.8333333 42.03125,95.8333333 L42.03125,95.8333333 Z"></path>
                        </svg>
                    </div>
                </button>
                <a :href="mobileIconPhoneNum()" class="desktop:hidden buyflow-button-alt ml-4 w-14 h-14 flex items-center justify-center text-md" aria-label="Phone">
                    <IconPhone width="24" class="flex-shrink-0" />
                </a>
            </div>

        </div>
        <div class="desktop:absolute desktop:top-1/2 desktop:right-8 desktop:transform desktop:-translate-y-1/2 pt-2 desktop:pr-2 desktop:pt-0 text-center desktop:text-right text-sm print:right-0 print:pr-0">
            {{ address }}
        </div>
    </div>
</template>

<script>
    import IconPhone from "@/atoms/icons/IconPhone"

    export default {
        name: 'AppHeader',
        components: {
            IconPhone,
        },
        props: {
            address: {
                type: String,
                required: true,
                default: null,
            },
        },
        methods: {
            mobileIconPhoneNum(){
                return this.$store.state.meta.marketType === 'ohio' ? 'tel:855-284-3806' :
                this.$store.state.meta.marketType === 'fiber-competitive-equal-speed' ? 'tel:855-284-3806' :
                this.$store.state.meta.marketType === 'default' ? 'tel:855-284-3806' :
                'tel:855-284-3806';
            },

        }
    }
</script>
